import { buffer as TurfBuffer, feature as TurfFeature } from '@turf/turf';

export function calcularBuffer(geometria, bufferMetros) {
    if (!bufferMetros || typeof bufferMetros !== 'number') {
        return null;
    }

    try {
        let geometryObject;

        if (typeof geometria === 'string') {
            geometryObject = JSON.parse(geometria);
        } else {
            geometryObject = geometria;
        }

        let feature;
        if (geometryObject.type === 'Feature') {
            feature = geometryObject;
        } else if (geometryObject.type === 'FeatureCollection') {
            feature = geometryObject.features[0];
        } else {
            feature = TurfFeature(geometryObject);
        }

        const buffer = TurfBuffer(feature, bufferMetros, { units: 'meters' });

        return buffer.geometry;
    } catch (error) {
        return null;
    }
}
